import { MaybeString } from 'src/common/types';
import { PREFIXED_ROUTES } from 'src/common/constants';
import { ORIGIN_IDENTIFIERS } from 'src/common/constants';

/**
 * Returns true if the path of the URL matches the paths used for Zillow.com (and not for ZHL) or
 * contains the zillow hostname
 */
export const isZillowURL = (url: MaybeString): boolean => {
    if (!url) {
        // Not combining with the boolean expression below since type narrowing gets upset with that
        return false;
    }
    return url.includes(PREFIXED_ROUTES.ZHL_BASE_ON_ZILLOW) || url.includes(ORIGIN_IDENTIFIERS.ZILLOW);
};
